<template>
  <div class="package-card" :class="packageData.id === highlightPackage ? 'selected' : 'not-selected'">
    <!-- 가격 헤더 -->
    <div class="price-header">
      <div class="package-info">
        <!-- 사장님들이 가장 많이 선택한 플랜 -->
        <div v-if="packageData.id === 100" class="most-selected-package">
          <span>사장님들이 <span class="highlight">가장 많이 선택</span>했어요!</span>
        </div>

        <div class="package-title-wrapper">
          <div class="package-title-info">
            <div class="package-title">{{ packageData.title || '체험형 패키지' }}</div>
          </div>

          <v-radio color="primary-light" :value="packageData.id" :ripple="false" class="radio-button"></v-radio>
        </div>

        <div class="price-wrapper">
          <div class="price-info">
            <span class="amount">{{ packageData.perPerson || '15,000원' }}</span>
            <span class="unit">/인당</span>
            <span class="vat-info">VAT 별도</span>
          </div>
          <span v-if="packageData.originalPrice" class="original-price">{{ packageData.originalPrice }}</span>
        </div>
      </div>
    </div>

    <!-- 구분선 -->
    <!-- <div class="divider"></div> -->

    <!-- 기능 목록 -->
    <div class="features-list">
      <div v-for="(feature, index) in productFeatures" :key="`feature-${index}`">
        <div class="feature-item" :class="{ 'last-visible': index === productFeatures.length - 1 }">
          <div class="feature-content">
            <div class="feature-title">{{ feature.title }}</div>
          </div>
          <div class="feature-value">
            {{ getFeatureValue(feature, packageData) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PackageCardMobile',
  props: {
    packageData: {
      type: Object,
      required: true,
    },
    productFeatures: {
      type: Array,
      required: true,
    },
    selectedPackage: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      highlightPackage: 100,
    };
  },
  methods: {
    getFeatureValue(feature, packageData) {
      const engTitle = feature.title === '기간' ? 'month' : 'numberOfPeople';
      const packageFeature = packageData.features?.find(f => f.title === engTitle);
      if (engTitle === 'month') {
        return `${packageFeature?.value || 1}개월`;
      }
      if (engTitle === 'numberOfPeople') {
        return `${packageFeature?.value || 10}명`;
      }

      return packageFeature?.value || '-';
    },
  },
};
</script>

<style scoped lang="scss">
.package-card {
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  border: 1px solid var(--disabled_light, #f5f5f5);
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  padding: 24px 24px 16px 24px;
}

.price-header {
  .package-info {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 16px;
  }
}

.most-selected-package {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  background: rgba(234, 42, 58, 0.05);

  span {
    color: var(--default, #3a3a3a);
    font-family: 'Spoqa Han Sans Neo';
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;

    .highlight {
      color: var(--primary_light, #ea2a3a);
      font-weight: 700;
    }
  }
}

.package-title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .package-title-info {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .package-title {
      color: var(--default_dark, #202020);
      font-family: 'Spoqa Han Sans Neo';
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px; /* 142.857% */
    }
  }

  .radio-button {
    margin: 0;
    padding: 0;
  }
}

.price-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;

  .price-info {
    display: flex;
    align-items: baseline;
    gap: 8px;

    .amount {
      color: var(--default_dark, #202020);
      font-family: 'Spoqa Han Sans Neo';
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 28px; /* 140% */
    }

    .unit {
      color: var(--default_dark, #202020);
      font-family: 'Spoqa Han Sans Neo';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
    }

    .vat-info {
      color: var(--default_light, #808080);
      font-family: 'Spoqa Han Sans Neo';
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px; /* 150% */
    }
  }

  .original-price {
    color: var(--disabled_dark, #c2c2c2);
    font-family: 'Spoqa Han Sans Neo';
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-decoration-line: line-through;
  }
}

.divider {
  width: 100%;
  height: 1px;
  background: var(--disabled, #dbdbdb);
  margin: 0;
  padding: 0 24px;
}

.features-list {
  display: flex;
  flex-direction: column;
  border-top: 1px solid var(--disabled, #dbdbdb);
  padding-top: 8px;
  .feature-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid var(--disabled_light, #f5f5f5);
    &.last-visible {
      border-bottom: none;
    }

    .feature-content {
      flex: 1;

      .feature-title {
        color: var(--default-2, #484848);
        font-family: 'Spoqa Han Sans Neo';
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 142.857% */
      }
    }

    .feature-value {
      color: var(--default-2, #484848);
      text-align: right;
      font-family: 'Spoqa Han Sans Neo';
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px; /* 142.857% */
    }
  }
  .not-selected {
    background-color: #fff;
  }
  .selected {
    background: var(--inversed_dark, #fbfbfb);
  }
}

// v-radio
::v-deep .v-radio {
  margin: 0 !important;

  .v-input--selection-controls__input {
    margin: 0 !important;
  }

  .v-input--selection-controls__ripple {
    margin: 0 !important;
  }
}
</style>
